<template>
  <div class="container">
    <div class="articles-header">
      <h2 @click="eggog = !eggog" class="calendar__title title">
        {{ $t('articles.list.header.title') }}
      </h2>
      <Checkbox
        @change="changeArticlesLang"
        :isChecked="inAllLanguages"
        :text="$t('articles.list.header.languages')"
      />
    </div>
    <div class="articles-list">
      <a
        @click.prevent="$emit('open', article)"
        v-for="(article, i) in articlesChanged"
        :key="i"
        :href="`${$route.path}/${article.slug}`"
        class="preview"
        target="_blank"
        :class="{ eggog: eggog }"
      >
        <div class="image-wrapper">
          <img
            :alt="(article.image && article.image.alt) || article.title"
            :src="getImageUrl(article)"
            class="image"
          />
        </div>
        <div class="content">
          <span class="published">{{ article.published }}</span>
          <h3 class="title">
            {{ article.title | shortText(titleLength[$mq], '…') }}
          </h3>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import shortText from '@/utils/filters/shortText'
import Checkbox from '@/components/library/checkbox.vue'

export default {
  props: {
    articles: Array,
  },
  data() {
    return {
      inAllLanguages: false,
      eggog: false,
      titleLength: { sm: 120, md: 200, lg: 90, xl: 140, xxl: 120, xxxl: 130 },
    }
  },
  computed: {
    articlesChanged() {
      const arts = this.inAllLanguages
        ? this.articles
        : this.filterArticles(this.articles)
      for (let i = 0; i < arts.length; i++) {
        if (!arts[i].published)
          arts[i].published = new Intl.DateTimeFormat(this.$i18n.locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }).format(new Date(arts[i].published_at))
      }
      return arts
    },
  },
  methods: {
    getImageUrl(article) {
      const BO = process.env.VUE_APP_BACKOFFICE_URL.slice(0, -1)
      if (article.image && article.image.url) {
        return `${BO}${article.image.url}`
      }
      return `${BO}upload_default_preview.png`
    },
    changeArticlesLang() {
      this.inAllLanguages = !this.inAllLanguages
    },
    filterArticles(articles) {
      let filtered = []
      for (let i = 0; i < articles.length; i++) {
        if (articles[i].availableLangs.indexOf(this.$i18n.locale) > -1) {
          filtered.push(articles[i])
        }
      }
      return filtered
    },
  },
  filters: {
    shortText,
  },
  components: {
    Checkbox,
  },
}
</script>

<style lang="scss">
.articles-header {
  padding-top: 40px;
  margin-bottom: 34px;
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  .title {
    font-size: 32px;
  }
  @media (max-width: 576px) {
    margin-bottom: 20px;
    padding-top: 12px;
    gap: 0;
    .title {
      font-size: 22px;
      margin-right: 32px;
      margin-bottom: 0;
    }
  }
}

.articles-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 32px;

  > .preview {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;

    overflow: hidden;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;

    &:hover {
      box-shadow: 0px 5px 20px $primary-color2;
      transform: translate(0, -10px);
      transition: all 0.5s ease-in-out;
    }

    &.eggog:hover {
      transform: translate3d(0, -10%, 10px) rotate(36000deg);
      transition: all 5s ease-in-out;
    }

    > .image-wrapper {
      height: 268px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-content: center;

      > .image {
        margin: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    > .content {
      margin: 12px 20px 16px;
      min-height: 72px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      > .published {
        color: $text-color !important;
      }

      > .title {
        margin: 0;
        font-size: 18px;
        line-height: 24px;
      }
    }
  }

  @media (max-width: 575px) {
    grid-gap: 12px;
    > .preview {
      flex-direction: row;
      border-radius: 0;
      box-shadow: 0px 1px 0px #eaeaf5;
      padding-bottom: 12px;
      align-items: center;

      &:hover {
        transform: translate(0, 0);
        box-shadow: none;
      }

      > .image-wrapper {
        flex: 1 3 110px;
        border-radius: 4px;
        height: 72px;
        margin-right: 12px;
      }
      > .content {
        flex: 6 4 170px;
        padding: 0;
        margin: 0;
        flex-flow: column-reverse;

        > .published {
          font-size: 10px;
          line-height: 18px;
        }
        > .title {
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    > .preview {
      > .content {
        min-height: auto;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    grid-template-columns: 1fr 1fr;
  }
}

#app[data-theme='dark'] {
  .articles-title {
    color: #d6d6d6 !important;
  }

  .articles-list {
    > .preview {
      background: #222222;
      @media (max-width: 575px) {
        background: inherit;
        box-shadow: 0px 1px 0px #333333;
      }

      > .content {
        > .title {
          color: #d6d6d6 !important;
        }
      }
    }
  }
}
</style>
